"use client";

import { motion } from "motion/react";
import ReviewsSection from "./ReviewsSection";
import { AvatarRating } from "./AvatarRating";
import { useSectionView } from "@/app/utils/analytics";

export default function Testimonial() {
  const sectionRef = useSectionView("reviews");
  return (
    <section ref={sectionRef}>
      <div
        className={`bg-ink flex flex-col justify-center items-center w-full px-6 py-24 overflow-hidden`}
        id="reviews"
      >
        <motion.div className="w-full xl:w-[1250px] mx-auto relative flex flex-col justify-center items-center">
          <div
            className={`mb-6 inline-flex items-center gap-2 rounded-full border border-line bg-panel/70 px-4 py-1.5 text-sm font-medium text-zinc-300 shadow-sm backdrop-blur`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-primary"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              <path d="M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8" />
            </svg>
            Reviews
          </div>
          <h2 className="text-4xl md:text-5xl font-medium text-white tracking-tight text-center max-w-3xl mx-auto mb-4">
            What <span className="text-primary">builders</span> are saying
          </h2>
          <motion.div className="w-full">
            <AvatarRating />
            <ReviewsSection />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
